import React from "react";
import logo from "../../Assets/logo-pos1.png";

export const BizXPos = () => {
  return <img
    style={{ height: 45, pointerEvents: "none" }}
    src={logo}
    alt="logo"
  />
};